var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 255,
    viewBox: "0 0 256 255",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.5 195.022H0.5V195.15H255.5V195.022Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.95 203.231H213.058V203.359H229.95V203.231Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.635 203.231H170.524V203.359H206.635V203.231Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 198.496H140.822V198.624H150.61V198.496Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7418 199.353H27.2539V199.48H44.7418V199.353Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0797 199.353H49.2822V199.48H81.0797V199.353Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.325 201.507H96.5498V201.634H115.325V201.507Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.377 172.278H22.8964C21.2915 172.278 19.9854 170.972 19.9854 169.367V30.9365C19.9854 29.3315 21.2915 28.0254 22.8964 28.0254H121.377C122.981 28.0254 124.287 29.3315 124.287 30.9365V169.367C124.287 170.972 122.981 172.278 121.377 172.278ZM22.8964 28.1534C21.3613 28.1534 20.1129 29.4019 20.1129 30.937V169.367C20.1129 170.902 21.3613 172.151 22.8964 172.151H121.377C122.912 172.151 124.16 170.902 124.16 169.367V30.9365C124.16 29.4019 122.912 28.1529 121.377 28.1529L22.8964 28.1534Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.688 172.278H133.208C131.603 172.278 130.298 170.972 130.298 169.367V30.9365C130.298 29.3315 131.604 28.0254 133.208 28.0254H231.688C233.294 28.0254 234.599 29.3315 234.599 30.9365V169.367C234.6 170.972 233.294 172.278 231.688 172.278ZM133.208 28.1534C131.674 28.1534 130.425 29.4019 130.425 30.937V169.367C130.425 170.902 131.674 172.151 133.208 172.151H231.688C233.223 172.151 234.472 170.902 234.472 169.367V30.9365C234.472 29.4019 233.223 28.1529 231.688 28.1529L133.208 28.1534Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1753 98.543L108.382 98.543L108.382 38.5818L39.1753 38.5818L39.1753 98.543Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6363 98.543L106.843 98.543L106.843 38.5818L37.6363 38.5818L37.6363 98.543Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.083 96.4003L104.083 40.7246L40.3978 40.7246L40.3978 96.4003L104.083 96.4003Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5407 96.4003L90.0789 40.7246H65.9401L54.4014 96.4003H78.5407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5596 96.4003L41.5596 40.7246H40.3968L40.3968 96.4003H41.5596Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7785 86.417L105.701 86.417V83.5401L38.7785 83.5401V86.417Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.176 191.986H116.227V144.061H105.176V191.986Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9987 195.023H114.104V191.987H32.9987V195.023Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.176 144.061H30.877V191.986H105.176V144.061Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.83 149.959H35.2207V165.677H100.83V149.959Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.83 170.369H35.2207V186.087H100.83V170.369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3433 158.896H85.7087C86.3013 158.896 86.7863 158.411 86.7863 157.819C86.7863 157.226 86.3013 156.741 85.7087 156.741H50.3433C49.7506 156.741 49.2656 157.226 49.2656 157.819C49.2656 158.411 49.7506 158.896 50.3433 158.896Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3433 179.306H85.7087C86.3013 179.306 86.7863 178.821 86.7863 178.228C86.7863 177.635 86.3013 177.15 85.7087 177.15H50.3433C49.7506 177.15 49.2656 177.635 49.2656 178.228C49.2656 178.821 49.7506 179.306 50.3433 179.306Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.628 69.9217C226.922 68.1872 229.074 56.7693 213.17 52.1084C216.678 63.591 209.656 72.946 220.628 69.9217Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.02 74.8781C226.979 69.5159 222.288 57.3917 204.419 62.3448C214.529 71.1908 213.374 84.2269 222.02 74.8781Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.122 76.2533C212.969 72.1422 218.917 57.8383 232.626 64.4672C224.858 71.8944 224.362 83.4204 217.122 76.2533Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.983 84.2622H225.065L225.976 76.0879H212.071L212.983 84.2622Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.935 77.5495H226.112C226.611 77.5495 227.015 77.1456 227.015 76.6473C227.015 76.149 226.611 75.7451 226.112 75.7451H211.935C211.437 75.7451 211.033 76.149 211.033 76.6473C211.034 77.1456 211.438 77.5495 211.935 77.5495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.327 181.177V167.333H122.861V153.488H134.394V139.643H145.929V125.798H157.462V111.953H168.996V98.1082H180.53V84.2627H192.064H255.5V195.022H111.327H99.793V181.177H111.327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.763 181.177V167.333H186.297V153.488H197.83V139.643H209.365V125.798H220.898V111.953H232.432V98.1082H243.966V84.2627H255.5V98.1082V195.022H174.763H163.229V181.177H174.763Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.229 181.178H99.1133V185.331H163.229V181.178Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.763 167.332H110.647V171.485H174.763V167.332Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.296 153.487H122.181V157.641H186.296V153.487Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.831 139.643H133.715V143.796H197.831V139.643Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.365 125.798H145.249V129.951H209.365V125.798Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.898 111.953H156.782V116.107H220.898V111.953Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.432 98.1074H168.316V102.261H232.432V98.1074Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.966 84.2627H179.851V88.4161H243.966V84.2627Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_11947_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 218.056C182.611 218.056 226.883 215.471 226.883 212.282C226.883 209.092 182.611 206.507 128 206.507C73.3878 206.507 29.1162 209.092 29.1162 212.282C29.1162 215.471 73.3878 218.056 128 218.056Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.037 124.386C135.912 133.762 108.75 121.808 99.3724 97.6777C89.995 73.5476 101.957 46.3885 126.081 37.0132C150.211 27.6353 177.373 39.5897 186.751 63.7199C196.129 87.85 184.167 115.009 160.037 124.386Z",
    fill: "#D9EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.555 34.6021L114.796 118.093C114.228 117.664 113.67 117.221 113.12 116.768C109.615 113.869 106.514 110.438 103.942 106.527L103.94 106.522L135.69 34.4093C141.032 33.5494 146.394 33.6458 151.555 34.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.688 49.0893L143.126 127.581C135.885 127.593 128.803 125.913 122.42 122.778L160.158 37.0625C166.78 39.6523 172.802 43.743 177.688 49.0893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48 49.1226C121.918 27.8148 153.33 24.6773 174.638 42.1147C195.946 59.5521 199.083 90.9645 181.646 112.272C164.206 133.584 132.793 136.721 111.485 119.284C90.1775 101.846 87.04 70.434 104.48 49.1226ZM178.492 109.691C194.503 90.1266 191.626 61.2831 172.058 45.2685C152.489 29.254 123.646 32.1391 107.635 51.7032C91.6208 71.2719 94.4978 100.115 114.066 116.13C133.635 132.145 162.478 129.259 178.492 109.691Z",
    fill: "#D9EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.891 109.517C187.802 112.449 192.473 115.674 197.064 118.997C201.653 122.323 206.127 125.789 210.531 129.341C214.936 132.891 219.25 136.553 223.416 140.394C225.504 142.31 227.546 144.281 229.55 146.299C231.548 148.324 233.517 150.385 235.366 152.592C236.385 153.808 236.225 155.619 235.009 156.638C234.08 157.417 232.797 157.503 231.792 156.959C229.263 155.583 226.853 154.062 224.472 152.503C222.098 150.938 219.761 149.327 217.471 147.659C212.881 144.334 208.439 140.83 204.087 137.214C199.735 133.599 195.452 129.9 191.284 126.059C187.119 122.217 183.034 118.275 179.188 114.041C178.09 112.833 178.18 110.964 179.388 109.867C180.375 108.971 181.804 108.869 182.891 109.517Z",
    fill: "#D9EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.498 117.07C158.38 114.585 160.856 112.823 163.469 112.823H204.294C207.392 112.823 209.611 115.274 209.251 118.297L198.708 206.808C198.348 209.831 195.545 212.281 192.447 212.281H62.8954C59.7976 212.281 57.5786 209.831 57.9387 206.808L66.7948 132.462C67.1549 129.439 69.9579 126.988 73.0556 126.988H143.551C149.654 126.988 155.438 122.875 157.498 117.07Z",
    fill: "#BCE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 208.207H195.644L203.357 117.131H68.0018L60.2891 208.207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 208.207H195.644L201.225 117.131H68.0018L60.2891 208.207Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 208.207H195.644L200.297 114.24H64.9418L60.2891 208.207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 208.207H195.644L197.485 114.24H64.9418L60.2891 208.207Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2891 208.207H195.644L196.45 111.69H61.0954L60.2891 208.207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2892 208.207H195.644L192.867 113.518H58.3828L60.2892 208.207Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2897 208.207H195.645L191.627 114.24H56.2725L60.2897 208.207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.289 208.207H195.644L189.247 115.657H53.8916L60.289 208.207Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2895 208.207H195.645L188.227 116.45H52.8721L60.2895 208.207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.071 122.817C128.16 120.271 130.074 118.466 132.687 118.466H173.512C176.61 118.466 179.611 120.977 180.216 124.074L196.344 206.672C196.949 209.77 194.928 212.281 191.831 212.281H62.279C59.1812 212.281 56.1799 209.77 55.575 206.672L42.2808 138.588C41.676 135.49 43.6966 132.979 46.7943 132.979H117.29C123.392 132.979 127.864 128.765 128.071 122.817Z",
    fill: "#BCE4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11947_13623",
    x: 33.6367,
    y: 38.582,
    width: 77.2061,
    height: 67.9609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11947_13623",
    x: 34.7783,
    y: 83.54,
    width: 74.9229,
    height: 10.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11947_13623",
    x: 26.877,
    y: 144.061,
    width: 82.2988,
    height: 55.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11947_13623",
    x: 45.2656,
    y: 156.741,
    width: 45.5205,
    height: 10.1553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_11947_13623",
    x: 45.2656,
    y: 177.15,
    width: 45.5205,
    height: 10.1553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_11947_13623",
    x: 25.1162,
    y: 206.507,
    width: 205.767,
    height: 19.5498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11947_13623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11947_13623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11947_13623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.4226d2496f987a1f17bec5645f18ccfc.svg";
export { ForwardRef as ReactComponent };